import { Grid, useMediaQuery, useTheme } from "@material-ui/core";
import {
  Block,
  ExpandMore,
  KeyboardArrowRight,
  Save,
} from "@material-ui/icons";
import CommonButton from "app/common/Component/Button/CommonButton";
import PopupForm from "app/common/Component/Popup/PopupForm";
import GlobitsNumberInput from "app/common/form/GlobitsNumberInput";
import GlobitsPagingAutocomplete from "app/common/form/GlobitsPagingAutocomplete";
import GlobitsVNDCurrencyInputOnlyChange from "app/common/form/GlobitsVNDCurrencyInputOnlyChange";
import IconDelete from "app/common/Icon/IconDelete";
import { LEAD_SOURCE_LEVEL } from "app/common/LocalConst";
import {
  formatMoney,
  getPositionCodes,
  validateEqualsSourceDiffirentTelesale,
  validateMaxTotalAmountTelesale,
  validateMaxTotalDiffTelesale,
  validateSelectDiffirentTelesale,
  validateSelectTelesale,
} from "app/common/LocalFunction";
import { pagingCustomerSource } from "app/services/CustomerSourceService";
import { pagingPosition } from "app/services/PositionService";
import { pagingStaff } from "app/services/StaffService";
import { FieldArray, getIn, useFormikContext } from "formik";
import { observer } from "mobx-react";
import React, { memo, useEffect, useState } from "react";
import * as Yup from "yup";

const StaffRevenueFeePopup = ({ open, handleClose, data, handleSubmit }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"));
  let { nameSpace, list } = data;

  const staffRevenuesSchema = Yup.array()
    .of(
      Yup.object()
        .shape({
          position: Yup.object().nullable().required("Bắt buộc nhập chức danh"),
          staff: Yup.object().nullable(),
          source: Yup.object().nullable(),
          actualAmount: Yup.number()
            .min(0, "Phân bổ doanh thu phải lớn hơn 0!")
            .nullable(),
          percentRevenue: Yup.number()
            .max(100, "Phân bổ doanh thu phải nhỏ hơn 100%")
            .nullable(),
        })
        .test(
          "at-least-one-selected",
          "Phải chọn Nhân viên!",
          function (value) {
            if (!value) return false;
            const { staff } = value;
            return !!staff;
          }
        )
    )
    .test(
      "at-least-one-diffirent-sale",
      "Cần chọn phân bổ cho người tư vấn!",
      validateSelectDiffirentTelesale
    )
    .test(
      "at-least-one-sale",
      "Cần chọn phân bổ cho telesale!",
      validateSelectTelesale
    )
    .test(
      "max-total-amount-telesale",
      "Tổng phân bổ telesale phải bằng 100%",
      validateMaxTotalAmountTelesale
    )
    .test(
      "max-total-amount-consultant",
      "Tổng phân bổ tư vấn viên và kĩ thuật viên phải bằng 100%",
      validateMaxTotalDiffTelesale
    )
    .test(
      "equals-source-revenue-sale-diffirent",
      "Tổng phân bổ telesale phải bằng các chức danh khác trong cùng nguồn!",
      validateEqualsSourceDiffirentTelesale
    )
    .nullable();

  const validationSchema = Yup.object().shape({
    [nameSpace]: Yup.object().shape({
      items: Yup.array().of(
        Yup.object().shape({
          staffRevenues: staffRevenuesSchema,
        })
      ),
    }),
  });

  return (
    <PopupForm
      open={open}
      size="lg"
      height="75vh"
      handleClose={handleClose}
      title={"Phân bổ hoa hồng"}
      formik={{
        initialValues: { [nameSpace]: list },
        enableReinitialize: true,
        onSubmit: handleSubmit,
        validationSchema: validationSchema,
      }}
      action={({ isSubmitting }) => {
        return (
          <div className="flex-center gap-1">
            <CommonButton type="submit">
              {!isMobile && <Save className="mr-2 " />}
              Hoàn thành
            </CommonButton>

            <CommonButton className="btn-gray" onClick={handleClose}>
              <Block className="mr-2" /> Đóng
            </CommonButton>
          </div>
        );
      }}
    >
      {({ setFieldValue, values }) => {
        return (
          <>
            <ValueForm data={data} />
          </>
        );
      }}
    </PopupForm>
  );
};

const ValueForm = observer(({ data }) => {
  const [listGroup, setlistGroup] = useState({});
  let POSITION_CODES = getPositionCodes();

  const toggleListGroup = (index, boolean) => {
    setlistGroup((prevStatus) => ({
      ...prevStatus,
      [index]: boolean ? boolean : !prevStatus[index],
    }));
  };

  useEffect(() => {
    if (data?.list?.items?.length > 0) {
      const newArr = data?.list?.items?.reduce((acc, _, index) => {
        acc[index] = true;
        return acc;
      }, {});

      setlistGroup(newArr);
    }
  }, []);
  const { values, setFieldValue } = useFormikContext();
  let viewData = values?.[data?.nameSpace];

  return (
    <FieldArray name="staffRevenues">
      {({ remove, push }) => (
        <>
          <div
            style={{
              backgroundColor: "aliceblue",
              height: "100%",
              boxShadow: "0 8px 24px rgba(0, 0, 0, 0.08)",
            }}
          >
            <Grid container spacing={1} className="m-0 w-100">
              <Grid item xs={12} className="search-title-card">
                <p className="title-block">{data?.title}</p>
              </Grid>

              <Grid item xs={12}>
                {viewData?.items?.length > 0 ? (
                  <>
                    {viewData?.items?.map((item, index) => {
                      let nameSpaceStaffRevenuesParent = `${data?.nameSpace}.items.[${index}].staffRevenues`;

                      return (
                        <>
                          <React.Fragment key={index}>
                            <div
                              style={{
                                borderBottom: "1px solid gray",
                                display: "flex",
                                justifyContent: "space-between",
                              }}
                            >
                              <div key={index} className="group-section">
                                <div className="group-header">
                                  <span
                                    onClick={() => toggleListGroup(index)}
                                    className="pointer"
                                  >
                                    {listGroup[index] ? (
                                      <ExpandMore />
                                    ) : (
                                      <KeyboardArrowRight />
                                    )}
                                  </span>

                                  <span className="group-title">
                                    {item.invoiceItemName}
                                  </span>
                                  <span className="total-amount ml-2">
                                    {formatMoney(item?.totalDetail)}
                                  </span>
                                </div>
                              </div>
                            </div>
                            {listGroup?.[index] && (
                              <Grid container spacing={1}>
                                <Grid item xs={12} md={12}>
                                  <StaffRevenuesTable
                                    item={item}
                                    nameSpaceStaffRevenuesParent={
                                      nameSpaceStaffRevenuesParent
                                    }
                                    POSITION_CODES={POSITION_CODES}
                                  />
                                </Grid>
                              </Grid>
                            )}
                          </React.Fragment>
                        </>
                      );
                    })}
                  </>
                ) : (
                  <tr>
                    <td colSpan={11} align="center">
                      Chưa có dữ liệu
                    </td>
                  </tr>
                )}
              </Grid>
            </Grid>
          </div>
        </>
      )}
    </FieldArray>
  );
});

const StaffRevenuesTable = observer(
  ({ item, nameSpaceStaffRevenuesParent, POSITION_CODES }) => {
    const { values, setFieldValue } = useFormikContext();

    return (
      <FieldArray name="staffRevenues">
        {({ remove, push }) => (
          <>
            {item?.staffRevenues?.length > 0 && (
              <table className="staff-table">
                <thead>
                  <tr>
                    <th width="5%">STT</th>
                    <th width="20%">Nguồn</th>
                    <th width="17%">Chức danh</th>
                    <th width="20%">Nhân viên</th>
                    <th width="15%">Phân bổ doanh thu(%)</th>
                    <th width="13%">Tiền phân bổ</th>
                    <th width="10%">Trạng thái</th>
                  </tr>
                </thead>
                <tbody>
                  {item?.staffRevenues.map((child, indexChild) => (
                    <tr key={indexChild}>
                      <td>{indexChild + 1}</td>
                      <td>
                        <GlobitsPagingAutocomplete
                          name={`${nameSpaceStaffRevenuesParent}[${indexChild}].source`}
                          api={pagingCustomerSource}
                          searchObject={{
                            level: LEAD_SOURCE_LEVEL.LEVEL_2.value,
                          }}
                        />
                      </td>
                      <td>
                        <GlobitsPagingAutocomplete
                          name={`${nameSpaceStaffRevenuesParent}[${indexChild}].position`}
                          api={pagingPosition}
                          searchObject={{
                            isUsing: true,
                            positionCodes: POSITION_CODES,
                          }}
                          onChange={function (_, value) {
                            setFieldValue(
                              `${nameSpaceStaffRevenuesParent}[${indexChild}].position`,
                              value
                            );
                            setFieldValue(
                              `${nameSpaceStaffRevenuesParent}[${indexChild}].staff`,
                              null
                            );
                          }}
                        />
                      </td>
                      <td style={{ fontWeight: "bold" }}>
                        <GlobitsPagingAutocomplete
                          api={pagingStaff}
                          displayLabel="staffName"
                          name={`${nameSpaceStaffRevenuesParent}[${indexChild}].staff`}
                          autoUpercase
                          searchObject={{
                            positionId: getIn(
                              values,
                              `${nameSpaceStaffRevenuesParent}[${indexChild}].position`
                            )?.id,
                          }}
                          onChange={function (_, value) {
                            setFieldValue(
                              `${nameSpaceStaffRevenuesParent}[${indexChild}].staff`,
                              value
                            );
                            let position = getIn(
                              values,
                              `${nameSpaceStaffRevenuesParent}[${indexChild}].position`
                            );
                            if (!position) {
                              setFieldValue(
                                `${nameSpaceStaffRevenuesParent}[${indexChild}].position`,
                                value?.position
                              );
                            }
                          }}
                        />
                      </td>
                      <td align="right">
                        <GlobitsNumberInput
                          name={`${nameSpaceStaffRevenuesParent}[${indexChild}].percentRevenue`}
                          onChange={(e) => {
                            let percentRevenue = +e?.target?.value;
                            setFieldValue(
                              `${nameSpaceStaffRevenuesParent}[${indexChild}].percentRevenue`,
                              percentRevenue
                            );
                            setFieldValue(
                              `${nameSpaceStaffRevenuesParent}[${indexChild}].actualAmount`,
                              (percentRevenue * item?.totalDetail) / 100
                            );
                          }}
                        />
                      </td>
                      <td align="right">
                        <GlobitsVNDCurrencyInputOnlyChange
                          isOnlyOnChange
                          name={`${nameSpaceStaffRevenuesParent}[${indexChild}].actualAmount`}
                          onChange={(e) => {
                            let actualAmount = +e?.target?.value;
                            setFieldValue(
                              `${nameSpaceStaffRevenuesParent}[${indexChild}].actualAmount`,
                              actualAmount
                            );
                            setFieldValue(
                              `${nameSpaceStaffRevenuesParent}[${indexChild}].percentRevenue`,
                              (actualAmount / item?.totalDetail) * 100
                            );
                          }}
                        />
                      </td>
                      <td>
                        <span
                          tooltip="Xóa"
                          className="pointer tooltip"
                          onClick={() => {
                            let currentArr =
                              getIn(
                                values,
                                `${nameSpaceStaffRevenuesParent}`
                              ) || [];
                            let newArr = currentArr?.filter(
                              (el, ind) => ind !== indexChild
                            );
                            setFieldValue(
                              `${nameSpaceStaffRevenuesParent}`,
                              newArr
                            );
                          }}
                        >
                          <IconDelete />
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </>
        )}
      </FieldArray>
    );
  }
);

export default memo(observer(StaffRevenueFeePopup));
